import * as $ from 'jquery';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').component('confirmXmlDetail', confirmXmlDetail());

  function confirmXmlDetail() {
    return {
      bindings: {
        item: '<',
        mode: '<',
        showActionsFromModal: '<',
        onConfirmXmlSaved: '&',
        onConfirmXmlCanceled: '&',
      },
      controller: ConfirmXmlDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/confirm-xmls/confirm-xml-detail/confirm-xml-detail.component.html',
    };
  }

  ConfirmXmlDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$routeParams',
    'SessionService',
    'AbilityService',
    'moment',
    'ConfirmXmlService',
    'ProviderService',
    '$location',
    'MeasurementUnitService',
    'DocumentTypeService',
    'TaxService',
    'ProductService',
    'ExchangeRateService',

    // Angular downgraded service
    'companyService',
    'currencyService',
  ];

  function ConfirmXmlDetailComponent(
    config,
    UtilService,
    $translate,
    $routeParams,
    SessionService,
    AbilityService,
    moment,
    ConfirmXmlService,
    ProviderService,
    $location,
    MeasurementUnitService,
    DocumentTypeService,
    TaxService,
    ProductService,
    ExchangeRateService,

    // Angular downgraded service
    companyService,
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_confirmxml_accountadmin'),
      canUpdate: AbilityService.can('update_confirmxml_accountadmin'),
    };

    vm.xmlfile = null;

    vm.match = false;
    vm.match_products = null;
    vm.xml_number = '';

    vm.dateDisplay = config.DATE_DISPLAY;

    // private properties
    // -----------------------
    let company = SessionService.getSelectedAccountCompany();
    let products = [];

    let condition_sale_xml = '';
    let currency_xml = '';
    let payment_method_xml = '';
    let confirm_xml_days_credit = '';
    let xml_name = '';
    let cr_key = '';
    let xml_signed = '';

    vm.products_added = [];
    vm.product_relation = [];
    vm.totals = null;

    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      if (vm.item.id && vm.mode !== 'xml') {
        // view - edit
        if (!vm.item.user_id) {
          vm.item.user_id = SessionService.currentUser().id;
        }

        setItemOptions(vm.item, vm.mode);

        // vm.documentDate = moment(vm.item.date);
        vm.documentDate = vm.UtilService.startOfDayFormat(vm.item.date); // yyyy-mm-ddT06:00:00.000Z
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          date: moment(),
          due_date: '',
          subtotal_services_taxable: 0,
          subtotal_services_exempt: 0,
          subtotal_goods_taxable: 0,
          subtotal_goods_exempt: 0,
          total_taxable: 0,
          total_exempt: 0,
          total_discount: 0,
          total_taxes: 0,
          grand_total: 0,
          confirm_xml_products: [],
          payment_method_codes: [],
          product_relation: [],
          company_id: company.id,
          user_id: SessionService.currentUser().id,
        };

        // vm.sendConfirmXmlToProvider = true;

        vm.documentDate = moment();
      }

      setPaymentDatePicker(false);

      // Initializers
      getCompany();
      getDocumentTypes();
    };

    vm.isInvalidHeader = function () {
      if (vm.viewMode) return false;

      if (
        vm.sendingForm ||
        !(
          vm.item.provider_id &&
          vm.item.currency_id &&
          vm.item.purchase_condition_code &&
          vm.item.document_type_id &&
          vm.item.user_id &&
          vm.item.date
        ) ||
        (vm.purchaseCondition &&
          vm.purchaseCondition.value === 'credit' &&
          !vm.item.credit_payment_days) ||
        (vm.purchaseCondition &&
          vm.purchaseCondition.value === 'cash' &&
          !vm.item.payment_method_code) ||
        (vm.createMode &&
          vm.documentType &&
          vm.documentType.numbering_type === 'manual' &&
          !vm.item.confirm_xml_number)
      ) {
        return true;
      }

      return false;
    };

    vm.selectDocumentType = function (documentType) {
      if (documentType.id === vm.lastDocumentTypeId) return;

      vm.documentType = documentType;
      vm.lastDocumentTypeId = documentType.id;

      setPaymentDatePicker(vm.documentType);
    };

    vm.onProviderSelected = function (provider) {
      let selectProviderCallback = function () {
        vm.lastProviderId = provider.id;
        vm.item.provider_id = provider.id;
        vm.item.provider = provider;

        vm.item.currency_id = provider.currency_id
          ? provider.currency_id
          : vm.companyBaseCurrencyId;

        let currency = vm.currenciesPerCompany.find((item) => item.id === provider.currency_id);
        // let currency;
        // if (vm.item.status !== 'confirm_later') {
        // }

        vm.selectCurrency(currency, true);

        vm.item.purchase_condition_code = null;

        if (vm.item.payment_method_code) {
          vm.item.payment_method_code = null;
          vm.item.payment_method_id = null;
        }

        vm.item.credit_payment_days = null;
        vm.item.due_date = null;

        let providerSaleCondition;

        if (provider.credit_enabled) {
          // Provider has credit enabled
          vm.providerPurchaseConditions = vm.company.sale_conditions;
          providerSaleCondition = vm.providerPurchaseConditions.find(
            (item) => item.value === 'credit'
          );
        } else {
          let purchaseConditions = angular.copy(vm.company.sale_conditions);
          vm.providerPurchaseConditions = vm.UtilService.removeItemFromArray(
            purchaseConditions,
            'value',
            'credit'
          );
          providerSaleCondition = vm.providerPurchaseConditions.find(
            (item) => item.value === 'cash'
          );
        }

        vm.item.purchase_condition_code = providerSaleCondition.code;

        vm.selectPurchaseCondition(providerSaleCondition);
      };

      selectProviderCallback();
    };

    // When provider is empty
    vm.onProviderValidated = function (provider) {
      vm.item.provider = provider;

      if (!vm.item.provider && vm.item.provider_id) {
        resetProviderInput();
      }
    };

    vm.onProviderCleared = function (clearObj) {
      if (clearObj) {
        vm.item.provider = null;
      }

      resetProviderInput();
    };

    vm.selectCurrency = function (currency, setCurrency) {
      if (currency.id === vm.lastCurrencyId && !setCurrency) return;

      vm.documentDateExchangeRate = getDocumentDateExchangeRate(currency.id);

      vm.item.exchange_rate_value = vm.documentDateExchangeRate.value;
      vm.item.base_currency_symbol = vm.currenciesPerCompany.find(
        (x) => x.id === vm.companyBaseCurrencyId
      ).symbol;

      if (!vm.documentDateExchangeRate.value) {
        return;
      }

      let selectCurrenyCallback = () => {
        vm.item.currency = currency;
        vm.lastCurrencyId = currency.id;
        vm.lastCurrency = currency;

        if (vm.mode === 'xml') {
          // check if needed
          vm.item.currency_id = currency.id;
        }
      };

      if (setCurrency) {
        selectCurrenyCallback();
        return;
      }

      if (!vm.viewMode) {
        if (vm.item.confirm_xml_products.length > 0) {
          if (vm.editMode) {
            vm.lastCurrencyId = vm.item.currency.id;
          }

          convertConfirmXmlProductsCostAndPrices(currency, vm.lastCurrencyId);
        }

        selectCurrenyCallback();
      }
    };

    vm.selectPurchaseCondition = function (purchaseCondition) {
      // Same open condition selected
      if (vm.purchaseCondition === purchaseCondition) return;

      vm.purchaseCondition = purchaseCondition;
      vm.item.due_date = moment();
      vm.item.credit_payment_days = null;
      vm.item.payment_method_code = null;
      vm.item.payment_method_id = null;

      if (purchaseCondition.value === 'credit') {
        let creditPaymentTerm;

        if (vm.item.provider) {
          creditPaymentTerm = vm.company.credit_payment_terms.find(
            (item) => item.id === vm.item.provider.default_credit_payment_term_id
          );
        }

        if (creditPaymentTerm || condition_sale_xml === '02') {
          // 02 = ??
          vm.item.credit_payment_days =
            vm.mode === 'xml' ? parseInt(confirm_xml_days_credit) : creditPaymentTerm.days;

          if (vm.mode !== 'xml') {
            vm.selectCreditPaymentTerm(creditPaymentTerm.days);
          }
        }
      }
    };

    vm.selectCreditPaymentTerm = function (creditPaymentTermDays) {
      let dueDate = angular.copy(vm.item.date); // Important
      vm.item.due_date = moment(dueDate).add(creditPaymentTermDays, 'days');
    };

    vm.selectPaymentMethod = function () {
      if (vm.mode !== 'xml') return;

      vm.item.payment_method_code = payment_method_xml;
      vm.paymentMethod = vm.company.payment_methods.find(
        (item) => item.code === vm.item.payment_method_code
      );
    };

    vm.openProviderFastCreate = function () {
      let successCallback = function (provider) {
        vm.onProviderSelected(provider);
      };

      ProviderService.openProviderFastCreate({}, successCallback);
    };

    vm.openProviderInfoModal = function (provider) {
      ProviderService.openProviderInfoModal(provider);
    };

    vm.addConfirmXmlProduct = function () {
      vm.item.confirm_xml_products.push({
        quantity: 1,
        unit_cost: 0,
        total_amount: 0,
        discount_percentage: 0,
        discount_amount: 0,
        subtotal_cost: 0,
        tax_percentage: 0,
        tax_amount: 0,
        total_cost: 0,
      });
    };

    vm.removeConfirmXmlProduct = function (index) {
      vm.item.confirm_xml_products.splice(index, 1);
      products = vm.item.confirm_xml_products;

      calculateConfirmXmlTotals();
    };

    vm.searchProduct = function (confirmXmlProduct, value) {
      confirmXmlProduct.product_id = null;

      return ProductService.searchProducts({ value: value, skip_check_role: true }).then(function (
        data
      ) {
        if (data.length === 0) {
          resetProductFilter(confirmXmlProduct);
        }

        return data;
      });
    };

    // When product is empty
    vm.checkSearchProduct = function (confirmXmlProduct) {
      if (!confirmXmlProduct.product && confirmXmlProduct.product_id) {
        resetProductFilter(confirmXmlProduct);
      }
    };

    vm.selectProduct = function (confirmXmlProduct, product) {
      if (vm.atvCrEnabled) {
        confirmXmlProduct.type = '04'; // 04 = TODO: @kevin uso interno - WHY ?? make it dynamic
      } else {
        confirmXmlProduct.type = '00'; // 0 =
      }

      products.push(product);

      confirmXmlProduct.product_id = product.id;
      confirmXmlProduct.product_code = product.code;
      confirmXmlProduct.product_name = product.name;
      confirmXmlProduct.product_type = product.type;
      confirmXmlProduct.tax_id = null;

      confirmXmlProduct.measurement_unit_id =
        product.measurement_unit_id || product.product_category.measurement_unit_id;
      confirmXmlProduct.measurement_units = MeasurementUnitService.setMeasurementUnitsByProductType(
        vm.company.measurement_units,
        confirmXmlProduct.product_type
      );

      let measurementUnit = confirmXmlProduct.measurement_units.find(
        (item) => item.id === confirmXmlProduct.measurement_unit_id
      );

      vm.selectMeasurementUnit(confirmXmlProduct, measurementUnit);

      getTaxesPerProduct(confirmXmlProduct, product);

      vm.calculateConfirmXmlProductTotalCost(confirmXmlProduct);
    };

    vm.selectMeasurementUnit = function (confirmXmlProduct, measurementUnit) {
      if (!measurementUnit) return;

      confirmXmlProduct.measurement_unit = measurementUnit;
      confirmXmlProduct.measurement_unit_symbol = measurementUnit.symbol;
    };

    vm.changeConfirmXmlProductQuantity = function (confirmXmlProduct) {
      let quantityBooked = 0;
      let quantityBilled = 0;

      if (!confirmXmlProduct.id) {
        // Create
        quantityBooked = confirmXmlProduct.quantity_booked;
        quantityBilled = confirmXmlProduct.quantity_billed;
      } else {
        // Edit
        if (confirmXmlProduct.booking_item_id) {
          if (confirmXmlProduct.booking_item_service_item_id) {
            quantityBooked =
              confirmXmlProduct.booking_item_service_item.service_item.cost_type === 'per_person'
                ? confirmXmlProduct.booking_item_service_item.adults +
                  confirmXmlProduct.booking_item_service_item.children +
                  confirmXmlProduct.booking_item_service_item.infants +
                  confirmXmlProduct.booking_item_service_item.seniors
                : 1;
            quantityBilled = confirmXmlProduct.booking_item_service_item.quantity_billed;
          } else {
            quantityBooked =
              confirmXmlProduct.booking_item.adults +
              confirmXmlProduct.booking_item.children +
              confirmXmlProduct.booking_item.infants +
              confirmXmlProduct.booking_item.seniors;
            quantityBilled = confirmXmlProduct.booking_item.quantity_billed;
          }

          confirmXmlProduct.originalQuantity = quantityBooked;
        }
      }

      if (
        confirmXmlProduct.booking_item_id &&
        confirmXmlProduct.quantity > quantityBooked - quantityBilled
      ) {
        let successCallback = function () {
          vm.calculateConfirmXmlProductTotalCost(confirmXmlProduct);

          return;
        };

        let cancelCallback = function () {
          confirmXmlProduct.quantity = confirmXmlProduct.originalQuantity;
        };

        let modalParams = {
          body: 'QUANTITY_PURCHASED_IS_HIGHER_THAN_BOOKED_WARNING',
        };

        vm.UtilService.warningMsg(modalParams, successCallback, cancelCallback);
      } else {
        vm.calculateConfirmXmlProductTotalCost(confirmXmlProduct);
      }
    };

    vm.editConfirmXmlProductRemarks = function (confirmXmlProduct) {
      vm.confirmXmlProduct = confirmXmlProduct;
    };

    vm.calculateConfirmXmlProductTotalCost = function (confirmXmlProduct) {
      confirmXmlProduct.quantity = confirmXmlProduct.quantity || 1;
      confirmXmlProduct.unit_cost = confirmXmlProduct.unit_cost || 0;
      confirmXmlProduct.discount_percentage = confirmXmlProduct.discount_percentage || 0;
      confirmXmlProduct.tax_percentage = confirmXmlProduct.tax_percentage || 0;

      let totalAmount = confirmXmlProduct.quantity * confirmXmlProduct.unit_cost;
      let discountAmount =
        vm.mode === 'xml'
          ? confirmXmlProduct.discount_percentage
          : totalAmount * (confirmXmlProduct.discount_percentage / 100);
      let subtotalCost = totalAmount - discountAmount;
      let taxAmount =
        vm.mode === 'xml'
          ? confirmXmlProduct.tax_amount
          : TaxService.setProductTotalTaxAmount(confirmXmlProduct.transaction_taxes, subtotalCost);
      let totalCost = subtotalCost + taxAmount;

      confirmXmlProduct.subtotal_cost = vm.UtilService.roundNum(subtotalCost);
      confirmXmlProduct.total_amount = vm.UtilService.roundNum(totalAmount);
      confirmXmlProduct.discount_amount = vm.UtilService.roundNum(discountAmount);
      confirmXmlProduct.tax_amount = vm.UtilService.roundNum(taxAmount);
      confirmXmlProduct.total_cost = vm.UtilService.roundNum(totalCost);

      calculateConfirmXmlTotals();
    };

    vm.editConfirmXml = function () {
      vm.editMode = true;
      vm.viewMode = false;

      vm.originalItem = angular.copy(vm.item); // store server data

      vm.match_products = angular.copy(vm.item.confirm_xml_products);
      vm.totals = angular.copy(vm.item);

      if (vm.item.status !== 'confirm_xml') {
        matchProducts();
      }

      getDocumentTypes();
      getCurrencies(vm.companyCurrencyIds);
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;

      setItemOptions(vm.item);
    };

    vm.saveConfirmXml = function (isFormValid, status, type, createBill = false) {
      let createConfirmXml = function () {
        vm.formErrors = false;

        if (!isFormValid) {
          vm.serverErrors = [];
          vm.formErrors = true;
          vm.UtilService.scrollToTop();

          return;
        }

        if (vm.item.status !== 'confirm_later') {
          for (let i = 0; i < vm.products_added.length; i++) {
            if (
              vm.item.confirm_xml_products[vm.products_added[i]] &&
              vm.match_products[vm.products_added[i]]
            ) {
              vm.product_relation.push({
                provider_id: vm.item.provider.id,
                product_code: vm.item.confirm_xml_products[vm.products_added[i]].product_code,
                product_xml_code: vm.match_products[vm.products_added[i]].product_code,
                product_name: vm.item.confirm_xml_products[vm.products_added[i]].product_name,
                product_xml_name: vm.match_products[vm.products_added[i]].product_name,
                symbol: vm.item.confirm_xml_products[vm.products_added[i]].measurement_unit_symbol,
              });
            } else {
              return;
            }
          }

          for (let i = 0; i < vm.item.confirm_xml_products.length; i++) {
            if (
              vm.item.confirm_xml_products[i].product_name == null &&
              vm.item.confirm_xml_products[i].product_code == null
            ) {
              vm.item.confirm_xml_products[i].product_name =
                vm.item.confirm_xml_products[i].product_name2.name;
              vm.item.confirm_xml_products[i].product_code =
                vm.item.confirm_xml_products[i].product_name2.code;
            }
          }
        }

        if (vm.item.payment_method_code) {
          vm.item.payment_method_codes.push(vm.item.payment_method_code);
        }

        vm.item.status = status;

        let confirm_xml = setConfirmXmlParams(type);

        vm.sendingForm = true;

        if (!createBill) {
          // ??
          ConfirmXmlService.saveConfirmXml(confirm_xml).then(function (data) {
            let status = data.status;
            let response = data.response;

            if (status) {
              if (vm.createMode) {
                // create
                vm.onConfirmXmlSaved({ item: response });
              } else if (vm.viewMode) {
                vm.item = response;

                setItemOptions(response);

                vm.purchaseCondition = vm.company.sale_conditions.find(
                  (item) => item.code === response.purchase_condition_code
                );

                vm.paymentMethod = vm.company.payment_methods.find(
                  (item) => item.code === response.payment_method_code
                );

                vm.user = vm.company.users.find((user) => user.id === response.user_id);

                if (response.credit_payment_days) {
                  vm.creditPaymentTerm = vm.company.credit_payment_terms.find(
                    (item) => item.days === response.credit_payment_days
                  );
                }

                setConfirmXmlProducts();
              }
            } else {
              vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
              vm.formErrors = true;
            }

            vm.UtilService.scrollToTop();

            vm.sendingForm = false;
          });
        } else {
          //
          ConfirmXmlService.createBillFromXml(confirm_xml).then(function (data) {
            let status = data.status;
            let response = data.response;

            if (status) {
              $location.path('/bills');
            } else {
              vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
              vm.formErrors = true;
            }

            vm.sendingForm = false;
          });
        }
      };

      vm.item.provider_email_receipt =
        vm.mode === 'xml' ? vm.item.provider_info.email : vm.item.provider.email;

      if (vm.totals && vm.item.status !== 'confirm_later') {
        if (
          vm.totals.grand_total !== vm.item.grand_total ||
          vm.totals.total_taxes !== vm.item.total_taxes ||
          vm.totals.total_discount !== vm.item.total_discount ||
          vm.totals.total_net_sale !== vm.item.total_net_sale ||
          vm.totals.grand_total !== vm.item.grand_total
        ) {
          // vm.totals.total_voucher !== vm.item.total_voucher

          let modalParams = {
            title: 'WARNING_INTUITIVE',
            body: 'TOTAL_NO_MATCH',
          };

          vm.UtilService.warningMsg(modalParams, null, null);
        } else {
          createConfirmXml();
        }
      } else {
        createConfirmXml();
      }
    };

    vm.cancel = function () {
      /*if (vm.editMode) {
                vm.cancelEdit();
                return;
            }*/

      vm.onConfirmXmlCanceled();
    };

    vm.downloadConfirmXmlPDF = function () {
      ConfirmXmlService.downloadConfirmXmlPDF(vm.item, userLanguageCode);
    };

    vm.selectIntuitiveMatch = function () {
      if (!vm.match) return;

      let modalParams = {
        title: 'WARNING_INTUITIVE',
        body: 'BODY_INTUITIVE',
      };

      vm.UtilService.warningMsg(modalParams, null, null);

      vm.item.confirm_xml_products = angular.copy(vm.match_products);
      vm.item = angular.copy(vm.totals);

      matchProducts();
    };

    vm.addProductMatch = function (index) {
      let myEl = angular.element(document.querySelector('#b' + index));

      if (myEl.hasClass('match_button')) {
        vm.products_added.push(index);
        myEl.addClass('match_button2');
        myEl.removeClass('match_button');
      } else {
        vm.products_added = vm.products_added.filter((value) => value !== index);
        myEl.addClass('match_button');
        myEl.removeClass('match_button2');
      }
    };

    vm.deleteProductMatch = function (index) {
      vm.item.confirm_xml_products[index].product_name = null;
      vm.item.confirm_xml_products[index].product_code = null;

      let myEl = angular.element(document.querySelector('#b' + index));
      let atag = angular.element(document.querySelector('#a' + index));

      myEl.addClass('hide_button');
      atag.addClass('hide_button');
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editConfirmXml();
      }

      if (
        item.is_from_booking &&
        item.confirm_xml_products.length > 0 &&
        item.bookings.length > 0
      ) {
        setProductsFromBooking();
      }

      products = vm.item.confirm_xml_products;
    }

    function setProductsFromBooking() {
      vm.item.confirm_xml_products.forEach(function (product) {
        vm.item.bookings.forEach(function (booking) {
          booking.booking_items.forEach(function (bookingItem) {
            if (product.booking_item_id === bookingItem.id) {
              product.booking_number = booking.booking_number;
            }
          });
        });
      });
    }

    // Initializers
    function getCompany() {
      vm.loadingCurrenciesPerCompany = true;

      vm.loadingCompany = false;
      vm.loadingConfirmXmlProducts = true; // !important

      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          vm.company = response;

          vm.companyBaseCurrencyId = vm.company.currency_id;
          vm.companyCurrencyIds = vm.company.currency_ids;

          // Create / Edit
          if (!vm.viewMode) {
            getCurrencies(vm.companyCurrencyIds);
          }

          // View / Edit
          if (!vm.createMode) {
            vm.purchaseCondition = vm.company.sale_conditions.find(
              (saleCondition) => saleCondition.code === vm.item.purchase_condition_code
            );

            vm.providerPurchaseConditions = vm.company.sale_conditions;

            // Provider with credit disabled - viewMode
            if (!vm.item.provider.credit_enabled) {
              let purchaseConditions = angular.copy(vm.providerPurchaseConditions);
              vm.providerPurchaseConditions = vm.UtilService.removeItemFromArray(
                purchaseConditions,
                'value',
                'credit'
              );
            }

            if (vm.item.credit_payment_days) {
              vm.creditPaymentTerm = vm.company.credit_payment_terms.find(
                (creditPaymentTerm) => creditPaymentTerm.days === vm.item.credit_payment_days
              );
            }

            if (vm.item.payment_method_code) {
              vm.paymentMethod = vm.company.payment_methods.find(
                (paymentMethod) => paymentMethod.code === vm.item.payment_method_code
              );
            }

            vm.user = vm.company.users.find((user) => user.id === vm.item.user_id);

            setConfirmXmlProducts();
          } else {
            vm.loadingConfirmXmlProducts = false; // !important
          }

          vm.loadingCompany = true;
        });
    }

    function getDocumentTypes() {
      if (vm.documentTypes) return;

      let params = {
        get: 'active',
        transaction_type: 'bills',
        skip_check_role: true,
      };

      vm.loadingDocumentTypes = true;
      DocumentTypeService.getDocumentTypes(params).then(function (data) {
        vm.documentTypes = data.items;

        if (vm.mode === 'xml') {
          vm.documentType = vm.documentTypes.find((documentType) => documentType.idt === 10); // TODO: 10 is ??
          vm.item.document_type_id = vm.documentType.id;

          vm.documentTypes = vm.documentTypes.filter((item) => item.idt !== 8);
        }

        vm.lastDocumentTypeId = vm.documentType.id;

        setPaymentDatePicker(vm.documentType);

        vm.loadingDocumentTypes = false;
      });
    }

    function getCurrencies(companyCurrencyIds) {
      if (vm.currenciesPerCompany) return;

      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
        // documentDate: null,
      };

      if (!vm.createMode) {
        params.documentDate = vm.documentDate;
      }

      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currenciesPerCompany = response;

        if (vm.mode === 'xml' && $routeParams.xml !== 'NO FILE') {
          getXMLFile();
        } else if (vm.editMode) {
          vm.selectCurrency(vm.item.currency, true);
        }

        vm.loadingCurrenciesPerCompany = false;
      });
    }

    function resetProviderInput() {
      vm.item.provider_id = null;
      vm.item.currency_id = null;
      vm.item.purchase_condition_code = null;
      vm.item.credit_payment_days = null;
      vm.item.due_date = null;

      if (vm.item.payment_method_code) {
        vm.item.payment_method_code = null;
      }

      vm.item.confirm_xml_products = vm.item.confirm_xml_products;
    }

    function getDocumentDateExchangeRate(currencyId) {
      return ExchangeRateService.getDocumentDateExchangeRate(
        vm.currenciesPerCompany,
        vm.companyBaseCurrencyId,
        currencyId
      ); // , vm.documentDate
    }

    function resetProductFilter(confirmXmlProduct) {
      confirmXmlProduct.product_id = null;
      confirmXmlProduct.measurement_unit_id = null;
      confirmXmlProduct.quantity = 1;
      confirmXmlProduct.unit_cost = 0;
      confirmXmlProduct.discount_percentage = 0;
      confirmXmlProduct.tax_percentage = 0;
      confirmXmlProduct.tax_amount = 0;
      confirmXmlProduct.total_cost = 0;

      vm.calculateConfirmXmlProductTotalCost(confirmXmlProduct);
    }

    function getTaxesPerProduct(confirmXmlProduct, product) {
      product = confirmXmlProduct.product || product;

      let documentDate = moment(vm.item.date);

      let productTaxes = TaxService.setProductTaxes(product, documentDate).purchaseTaxes;

      if (productTaxes) {
        confirmXmlProduct.transaction_taxes = productTaxes;
      }
    }

    function setPaymentDatePicker(documentType) {
      if (!documentType) return;

      let minDate = documentType.allows_past_days ? false : moment();
      let maxDate = documentType.allows_future_days ? false : moment();

      let onChangeDate = () => {
        // vm.documentDate = moment(vm.item.date);
        // getDocumentDateExchangeRate(vm.item.currency_id);

        // if (vm.item.due_date) {
        //     vm.selectCreditPaymentTerm(vm.item.credit_payment_days);
        // }

        let today = moment();
        let selectedDate = moment(vm.item.date);

        if (selectedDate > today) {
          let successCallback = function () {
            return;
          };

          let cancelCallback = function () {
            vm.item.date = today;
          };

          let modalParams = {
            body: 'FUTURE_DATE_WARNING_MSG',
          };

          vm.UtilService.warningMsg(modalParams, successCallback, cancelCallback);
        }
      };

      vm.datePickerOptions = vm.UtilService.singleDatePickerOptions({
        minDate: minDate,
        maxDate: maxDate,
        dateDisplay: vm.dateDisplay,
        onChangeDate: onChangeDate,
      });
    }

    function calculateConfirmXmlTotals() {
      let subtotal_services_taxable = 0;
      let subtotal_services_exempt = 0;
      let subtotal_services_exonerable = 0;
      let subtotal_goods_taxable = 0;
      let subtotal_goods_exempt = 0;
      let subtotal_goods_exonerable = 0;

      let total_sale = 0;
      let total_discount = 0;
      let total_net_sale = 0;
      let total_taxes = 0;
      let total_tax_exonerations = 0;
      let total_net_taxes = 0;
      let grand_total = 0;

      vm.item.confirm_xml_products.forEach(function (confirm_xml_product) {
        let total_amount = confirm_xml_product.total_amount;

        if (!confirm_xml_product.is_exempt) {
          if (
            confirm_xml_product.measurement_unit &&
            confirm_xml_product.measurement_unit.is_a_service
          ) {
            if (confirm_xml_product.tax_exoneration_amount > 0) {
              subtotal_services_taxable +=
                (1 -
                  (confirm_xml_product.tax_exoneration_percentage * 1) /
                    confirm_xml_product.tax_percentage) *
                total_amount;
              subtotal_services_exonerable += total_amount - subtotal_services_taxable;
            } else {
              subtotal_services_taxable += total_amount;
            }
          } else {
            if (confirm_xml_product.tax_exoneration_amount > 0) {
              subtotal_goods_taxable +=
                (1 -
                  (confirm_xml_product.tax_exoneration_percentage * 1) /
                    confirm_xml_product.tax_percentage) *
                total_amount;
              subtotal_goods_exonerable += total_amount - subtotal_goods_taxable;
            } else {
              subtotal_goods_taxable += total_amount;
            }
          }
        } else {
          if (
            confirm_xml_product.measurement_unit &&
            confirm_xml_product.measurement_unit.is_a_service
          ) {
            subtotal_services_exempt += total_amount;
          } else {
            subtotal_goods_exempt += total_amount;
          }
        }

        total_sale += confirm_xml_product.total_amount;
        total_discount += confirm_xml_product.discount_amount;
        total_net_sale += confirm_xml_product.subtotal_cost; // total_amount - discount_amount
        total_taxes += confirm_xml_product.tax_amount;
        total_tax_exonerations += confirm_xml_product.tax_exoneration_amount;
        total_net_taxes += confirm_xml_product.net_tax_amount;
        grand_total += confirm_xml_product.total_cost;
      });

      let total_taxable = subtotal_services_taxable + subtotal_goods_taxable;
      let total_exempt = subtotal_services_exempt + subtotal_goods_exempt;
      let total_exonerable = subtotal_services_exonerable + subtotal_goods_exonerable;
      let total_retornable_taxes = 0;
      let total_other_charges = 0;
      // let total_sale             = total_taxable + total_exempt;
      // let total_net_sale         = total_sale - total_discount;
      // let grand_total            = total_sale + total_taxes - total_discount; // total_voucher

      vm.item.subtotal_services_taxable = vm.UtilService.roundNum(subtotal_services_taxable);
      vm.item.subtotal_services_exempt = vm.UtilService.roundNum(subtotal_services_exempt);
      vm.item.subtotal_services_exonerable = vm.UtilService.roundNum(subtotal_services_exonerable);
      vm.item.subtotal_goods_taxable = vm.UtilService.roundNum(subtotal_goods_taxable);
      vm.item.subtotal_goods_exempt = vm.UtilService.roundNum(subtotal_goods_exempt);
      vm.item.subtotal_goods_exonerable = vm.UtilService.roundNum(subtotal_goods_exonerable);

      vm.item.total_taxable = vm.UtilService.roundNum(total_taxable);
      vm.item.total_exempt = vm.UtilService.roundNum(total_exempt);
      vm.item.total_exonerable = vm.UtilService.roundNum(total_exonerable);
      vm.item.total_sale = vm.UtilService.roundNum(total_sale);
      vm.item.total_discount = vm.UtilService.roundNum(total_discount);
      vm.item.total_net_sale = vm.UtilService.roundNum(total_net_sale);

      vm.item.total_taxes = vm.UtilService.roundNum(total_taxes);
      vm.item.total_tax_exonerations = vm.UtilService.roundNum(total_tax_exonerations);
      vm.item.total_net_taxes = vm.UtilService.roundNum(total_net_taxes);
      vm.item.total_retornable_taxes = vm.UtilService.roundNum(total_retornable_taxes);
      vm.item.total_other_charges = vm.UtilService.roundNum(total_other_charges);
      vm.item.grand_total = vm.UtilService.roundNum(grand_total);

      if (vm.saleCondition.value === 'credit') {
        vm.item.balance_due = vm.item.grand_total;
      }
    }

    function convertConfirmXmlProductsCostAndPrices(currency, lastCurrencyId) {
      let applyExchangeRateConversion = (amount) =>
        ExchangeRateService.applyExchangeRateConversion(
          amount,
          vm.documentDateExchangeRateForConversions
        );

      // For conversions
      vm.documentDateExchangeRateForConversions =
        ExchangeRateService.getDocumentDateExchangeRateForConversions(
          vm.currenciesPerCompany,
          vm.companyBaseCurrencyId,
          currency.id,
          lastCurrencyId
        ); // , vm.documentDate

      vm.item.subtotal_services_taxable = applyExchangeRateConversion(
        vm.item.subtotal_services_taxable
      );
      vm.item.subtotal_services_exempt = applyExchangeRateConversion(
        vm.item.subtotal_services_exempt
      );
      vm.item.subtotal_services_exonerable = applyExchangeRateConversion(
        vm.item.subtotal_services_exonerable
      );
      vm.item.subtotal_goods_taxable = applyExchangeRateConversion(vm.item.subtotal_goods_taxable);
      vm.item.subtotal_goods_exempt = applyExchangeRateConversion(vm.item.subtotal_goods_exempt);
      vm.item.subtotal_goods_exonerable = applyExchangeRateConversion(
        vm.item.subtotal_goods_exonerable
      );

      vm.item.total_taxable = applyExchangeRateConversion(vm.item.total_taxable);
      vm.item.total_exempt = applyExchangeRateConversion(vm.item.total_exempt);
      vm.item.total_exonerable = applyExchangeRateConversion(vm.item.total_exonerable);
      vm.item.total_sale = applyExchangeRateConversion(vm.item.total_sale);

      vm.item.total_discount = applyExchangeRateConversion(vm.item.total_discount);
      vm.item.total_net_sale = applyExchangeRateConversion(vm.item.total_net_sale);
      vm.item.total_taxes = applyExchangeRateConversion(vm.item.total_taxes);
      vm.item.total_retornable_taxes = applyExchangeRateConversion(vm.item.total_retornable_taxes);
      vm.item.total_other_charges = applyExchangeRateConversion(vm.item.total_other_charges);
      vm.item.grand_total = applyExchangeRateConversion(vm.item.grand_total);
      vm.item.balance_due = applyExchangeRateConversion(vm.item.balance_due);

      if (vm.item.confirm_xml_products.length > 0) {
        vm.item.confirm_xml_products.forEach(function (confirmXmlItem) {
          confirmXmlItem.unit_cost = applyExchangeRateConversion(confirmXmlItem.unit_cost);
          confirmXmlItem.total_amount = applyExchangeRateConversion(confirmXmlItem.total_amount);
          confirmXmlItem.discount_amount = applyExchangeRateConversion(
            confirmXmlItem.discount_amount
          );
          confirmXmlItem.subtotal_cost = applyExchangeRateConversion(confirmXmlItem.subtotal_cost);
          confirmXmlItem.tax_amount = applyExchangeRateConversion(confirmXmlItem.tax_amount);
          confirmXmlItem.total_cost = applyExchangeRateConversion(confirmXmlItem.total_cost);
          // confirmXmlItem.taxable_base    = applyExchangeRateConversion(confirmXmlItem.taxable_base);
        });
      }

      // not needed as it was get in selectCurrency
      // vm.documentDateExchangeRate = getDocumentDateExchangeRate(currency.id);
      // vm.lastCurrencyId = currency.id;
      // vm.lastCurrency   = currency;
    }

    // We need to prepare the app for addiional logic
    function setConfirmXmlParams(type) {
      let confirmXml = angular.copy(vm.item);

      confirmXml.reception_type = null;

      // 05 =
      // 06 =
      // 07 =
      if (type === '05') {
        confirmXml.reception_type = '05';
        confirmXml.type = '05';
      } else if (type === '06') {
        confirmXml.reception_type = '06';
        confirmXml.type = '06';
      } else if (type === '07') {
        confirmXml.reception_type = '07';
        confirmXml.type = '07';
      }

      if (vm.mode === 'xml') {
        confirmXml.name_xml = xml_name;
        confirmXml.xml_file = btoa(unescape(encodeURIComponent(vm.xmlfile)));
        confirmXml.date = moment();
        confirmXml.xml_number = vm.xml_number;
        confirmXml.cr_key = cr_key;
        confirmXml.xml_signed = xml_signed;
      }

      confirmXml.product_relation = vm.product_relation;
      confirmXml.atv_cr_reception_status = '-';

      // confirmXml.payment_method   = vm.purchaseCondition.value;
      // confirmXml.balance_due      = vm.purchaseCondition.value === 'credit' ? vm.item.grand_total : 0.0; // check if needed

      delete confirmXml.currency;
      delete confirmXml.provider;
      delete confirmXml.bookings;

      confirmXml.confirm_xml_products.forEach(function (product) {
        delete product.$$hashKey;
        delete product.measurement_units;
        delete product.measurement_unit;
        delete product.product;
        delete product.originalQuantity;
        delete product.quantity_billed;
        delete product.quantity_booked;
        delete product.product_name2;
      });

      return confirmXml;
    }

    // Set related data to each confirm xml product
    function setConfirmXmlProducts() {
      vm.loadingConfirmXmlProducts = false;

      if (vm.item.confirm_xml_products.length === 0) return;

      vm.item.confirm_xml_products.forEach(function (confirmXmlProduct) {
        let measurementUnit = vm.company.measurement_units.find(
          (item) => item.symbol === confirmXmlProduct.measurement_unit_symbol
        );

        vm.selectMeasurementUnit(confirmXmlProduct, measurementUnit);
      });
    }

    // Get
    function getXMLFile() {
      // vm.sendConfirmXmlToProvider = false;

      if ($routeParams.xml === 'NO FILE') return;

      vm.xmlfile = $routeParams.xml;

      let xmlDoc = $.parseXML(vm.xmlfile.split('*********')[1]);

      let $xml = $(xmlDoc);

      let $cedula = $xml.find('Emisor').find('Identificacion').find('Numero');
      let $name_provider = $xml.find('Emisor').find('Nombre');
      let $phone_number = $xml.find('Emisor').find('Telefono').find('NumTelefono');
      let $tax_id_code = $xml.find('Emisor').find('Identificacion').find('Tipo');
      let $state_id = $xml.find('Emisor').find('Ubicacion').find('Provincia');
      let $city_id = $xml.find('Emisor').find('Ubicacion').find('Canton');
      let $district_id = $xml.find('Emisor').find('Ubicacion').find('Distrito');
      let $email = $xml.find('Emisor').find('CorreoElectronico');
      let $cr_key = $xml.find('Clave');
      let $number = $xml.find('NumeroConsecutivo');
      let $lines = $xml.find('DetalleServicio').find('LineaDetalle');
      let $quantity = $xml.find('DetalleServicio').find('LineaDetalle').find('Cantidad');
      let $unit_cost = $xml.find('DetalleServicio').find('LineaDetalle').find('PrecioUnitario');
      let $sub_total = $xml.find('DetalleServicio').find('LineaDetalle').find('SubTotal');
      let $total_amount = $xml.find('DetalleServicio').find('LineaDetalle').find('MontoTotal');
      let $name = $xml.find('DetalleServicio').find('LineaDetalle').find('Detalle');
      let $unid = $xml.find('DetalleServicio').find('LineaDetalle').find('UnidadMedida');
      let $condition_sale = $xml.find('CondicionVenta');
      let $plazo_credito = $xml.find('PlazoCredito');
      let $payment_method = $xml.find('MedioPago');
      let $type = $xml
        .find('DetalleServicio')
        .find('LineaDetalle')
        .find('CodigoComercial')
        .find('Tipo');
      let $code = $xml
        .find('DetalleServicio')
        .find('LineaDetalle')
        .find('CodigoComercial')
        .find('Codigo');
      let $currency_xml = $xml.find('ResumenFactura').find('CodigoTipoMoneda').find('CodigoMoneda');
      let $discount = $xml
        .find('DetalleServicio')
        .find('LineaDetalle')
        .find('Descuento')
        .find('MontoDescuento');

      xml_name = vm.xmlfile.split('*********')[0];
      vm.xml_number = $number[0].textContent;
      cr_key = $cr_key[0].textContent;
      currency_xml = $currency_xml[0].textContent;
      payment_method_xml = $payment_method[0].textContent;
      condition_sale_xml = $condition_sale[0].textContent;
      confirm_xml_days_credit =
        $plazo_credito[0] !== undefined ? $plazo_credito[0].textContent : null;

      vm.providerPurchaseConditions = vm.company.sale_conditions;

      let currency = vm.currenciesPerCompany.find((item) => item.code === currency_xml);
      let providerSaleCondition = vm.providerPurchaseConditions.find(
        (item) => item.code === condition_sale_xml
      );

      vm.selectPaymentMethod();
      vm.selectCurrency(currency, true);
      vm.selectPurchaseCondition(providerSaleCondition);

      vm.item.purchase_condition_code = providerSaleCondition.code;
      vm.item.payment_method_code = payment_method_xml;
      vm.item.provider_info = {
        name: $name_provider[0].textContent,
        tax_id_number: $cedula[0].textContent,
        tax_id_code: $tax_id_code[0].textContent,
        state_id: $state_id[0].textContent,
        city_id: $city_id[0].textContent,
        district_id: $district_id[0].textContent,
        email: $email[0].textContent,
        phone_number: $phone_number[0].textContent,
      };

      for (let i = 0; i < $lines.length; i++) {
        let tax_amount = 0.0;
        let transaction_taxes = [];

        for (let o = 0; o < $lines[i].children.length; o++) {
          if ($lines[i].children[o].nodeName === 'Impuesto') {
            let realAmount =
              parseInt($lines[i].children[o].children[3].textContent) === 0
                ? $lines[i].children[o].children[4].textContent
                : $lines[i].children[o].children[3].textContent;
            let obj = {
              computation_type: 'fixed',
              scope_type: 'purchases',
              value: $lines[i].children[o].children[2].textContent,
              amount: realAmount,
              tax_rate_code: $lines[i].children[o].children[1].textContent,
              tax_type: $lines[i].children[o].children[0].textContent,
            };

            tax_amount += Number(realAmount);
            transaction_taxes.push(obj);
          }
        }

        vm.item.confirm_xml_products.push({
          quantity: Number($quantity.length === 0 ? 0 : $quantity[i].textContent).toFixed(2),
          unit_cost: Number($unit_cost.length === 0 ? 0 : $unit_cost[i].textContent),
          total_amount: Number($total_amount.length === 0 ? 0 : $total_amount[i].textContent),
          discount_percentage: Number($discount.length === 0 ? 0 : $discount[i].textContent),
          discount_amount: Number($discount.length === 0 ? 0 : $discount[i].textContent),
          subtotal_cost: Number($sub_total.length === 0 ? 0 : $sub_total[i].textContent),
          tax_percentage: 0,
          transaction_taxes: transaction_taxes,
          type: $type.length === 0 ? '04' : $type[i].textContent,
          tax_amount: Number(tax_amount),
          product_name: $name[i].textContent,
          product_code: $code.length === 0 ? 0 : $code[i].textContent,
          measurement_unit_symbol: $unid.length === 0 ? 0 : $unid[i].textContent,
          total_cost:
            Number($sub_total.length === 0 ? 0 : $sub_total[i].textContent) + Number(tax_amount),
        });
      }

      calculateConfirmXmlTotals();
    }

    function matchProducts() {
      ConfirmXmlService.getConfirmXmls(vm.filterCriteria).then(function () {
        let confirm_xmls = ConfirmXmlService.items;
        let test = [];

        confirm_xmls = confirm_xmls.filter((x) => x.product_relation.length > 0);

        for (let i = 0; i < confirm_xmls.length; i++) {
          test.push(...confirm_xmls[i].product_relation); // .. TODO: test it
        }

        for (let i = 0; i < test.length; i++) {
          if (test[i].provider_id === vm.item.provider.id) {
            for (let p = 0; p < vm.match_products.length; p++) {
              if (
                test[i].product_xml_name === vm.match_products[p].product_name ||
                test[i].product_xml_code === vm.match_products[p].product_code
              ) {
                vm.item.confirm_xml_products[p].product_name2 = test[i].product_name;
                vm.item.confirm_xml_products[p].product_name = test[i].product_name;
                vm.item.confirm_xml_products[p].product_code = test[i].product_code;
                vm.item.confirm_xml_products[p].measurement_unit_symbol = test[i].symbol;

                let measurementUnit = vm.item.confirm_xml_products[p].measurement_units.find(
                  (item) => {
                    return item.symbol === vm.item.confirm_xml_products[p].measurement_unit_id
                      ? vm.item.confirm_xml_products[p].measurement_unit_id == null
                      : vm.item.confirm_xml_products[p].measurement_unit_symbol;
                  }
                );

                vm.selectMeasurementUnit(vm.item.confirm_xml_products[p], measurementUnit);
              }
            }
          }
        }
      });
    }
  }
})();
